export default __webpack_public_path__ + "../fonts/Circe-Bold.ttf";